import {
  handleBookingStepCompleted,
  addCabin,
  removeCabin,
  switchActiveCabin,
} from './booking_step_events'
import { AdobeEventHandler, AdobeEvent, Mutation } from 'pkg-trinity-client'
import { findStepIndex } from './helpers'
import { newPageMetaEventHandler, newEmptyPageMetaEventHandler } from './page_meta_event'
import { State } from './vuex'

export type Sender = (event: AdobeEvent) => void

export function newRouteChangeHandler(): AdobeEventHandler {
  const handlePageMetaEvent = newPageMetaEventHandler()
  const handleEmptyPageMetaEvent = newEmptyPageMetaEventHandler()
  let stepIndexHasSkipped: boolean = false
  return (mutation: Mutation, state: State): AdobeEvent[] => {
    // Send Page Meta Events (gaVirtPath) only on path and page change
    const pageMetaEvents = handlePageMetaEvent(
      mutation,
      state,
      findStepIndex(mutation.payload.to.fullPath),
      undefined,
    )
    const emptyPageMetaEvents = handleEmptyPageMetaEvent(
      mutation,
      state,
      0,
      undefined
    )
    if (mutation.payload.to.fullPath.startsWith('/kreuzfahrt/angebote'))
    {
      return emptyPageMetaEvents
    }
    switch (mutation.payload.to.name) {
      // case 'planning':
      //   return [...handlePageMetaEvent(mutation, state)]
      case 'bookingPersons':
      case 'bookingCabinCategory':
      case 'bookingTransport':
      case 'bookingPax':
      case 'bookingInsurance':
      case 'bookingCheckout':
        if (
          (mutation.payload.from.name == null ||
          mutation.payload.from.name.startsWith('booking') === false) &&
          mutation.payload.from.fullPath.startsWith('/kreuzfahrt/angebote') === false
        ) {
          // Send events for all completed steps when previous route is not from booking
          stepIndexHasSkipped = true
          const index = findStepIndex(mutation.payload.to.fullPath)
          let steps: AdobeEvent[] = []
          for (let i = 0; i <= index; i++) {
            steps = [
              ...steps,
              ...handleBookingStepCompleted(
                mutation,
                state,
                i,
                stepIndexHasSkipped,
              ),
            ]
          }
          // }
          stepIndexHasSkipped = false
          return [...pageMetaEvents, ...steps]
        }
        if (mutation.payload.from.fullPath.startsWith("/kreuzfahrt/angebote"))
        {
          const index = findStepIndex(mutation.payload.to.fullPath)
          return [...handleBookingStepCompleted(mutation, state, index, false, undefined, false, true)]
        }
        if (mutation.payload.from.name != mutation.payload.to.name) {
          const index = findStepIndex(mutation.payload.to.fullPath)
          return [...handleBookingStepCompleted(mutation, state, index)]
        }
      case 'bookingLoading':
        let index = findStepIndex(mutation.payload.to.fullPath)
        if (index == -1) {
          let event = handleBookingStepCompleted(mutation, state, 6)
          return event
        } else {
          return []
        }
      case 'bookingSuccess':
        const events = handleBookingStepCompleted(
          mutation,
          state,
          7,
          false,
          'orderComplete',
          true,
        )

        return events
    }
    return pageMetaEvents
  }
}

export function addCabins(): AdobeEventHandler {
  return (_mutation: Mutation, state: State): AdobeEvent[] => {
    return [...addCabin(state)]
  }
}

export function removeCabins(): AdobeEventHandler {
  return (_mutation: Mutation, state: State): AdobeEvent[] => {
    return [...removeCabin(state)]
  }
}

export function switchActiveCabins(): AdobeEventHandler {
  return (_mutation: Mutation, state: State): AdobeEvent[] => {
    return [...switchActiveCabin(state)]
  }
}
